// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_94-0";
export var optionCard = "_94-1";